/** Stable viewer-relative seat anchors, shared by the GPU and DOM renderers. */
export function seatRingAnchors(ids: string[], self: string | null) {
  const start = Math.max(0, self ? ids.indexOf(self) : 0);
  return ids.map((id, at) => {
    const index = (at - start + ids.length) % ids.length;
    const angle = Math.PI / 2 + index * Math.PI * 2 / ids.length;
    return { id, x: 500 + Math.cos(angle) * 415, y: 300 + Math.sin(angle) * 235 };
  });
}
export type TableMode = 'animated' | 'battery' | 'still';
export function defaultTableMode(phone: boolean, reduced: boolean, saveData: boolean): TableMode { return phone || reduced || saveData ? 'battery' : 'animated'; }
/** Device signals may reduce effects without overwriting the viewer's preference. */
export function effectiveTableMode(saved:TableMode|null,phone:boolean,reduced:boolean,saveData:boolean,lowBattery=false):TableMode{
  if(saved==='still'||saved==='battery')return saved;
  if(reduced||saveData||lowBattery)return 'battery';
  return saved??defaultTableMode(phone,false,false);
}
